import React from 'react'
import { Form } from 'antd'
import { Col } from 'antd'
import { Input } from 'antd'
import { InputNumber } from 'antd'
import { defaultFormItemLayout } from '../../../../modules/FormItems'
import { rules } from '../../../../modules/FormItems'
import { get } from 'lodash'
import { DueTypeSelect } from '../../../../components/Sales/Quotes/AddQuote/QuoteForm'

PaymentTermsForm.propTypes = {}

function PaymentTermsForm(props) {
  const { getFieldDecorator, getFieldValue } = props.form
  const { paymentTerm } = props
  return (
    <Form>
      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label={'No'}>
          {getFieldDecorator('no', {
            initialValue: get(paymentTerm, 'no'),
            rules: rules.input,
          })(<Input placeholder={'No'} />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label="Percentage">
          {getFieldDecorator('percentage', {
            initialValue: get(paymentTerm, 'percentage'),
            rules: rules.input,
          })(
            <InputNumber
              formatter={value => `${value}%`}
              parser={value => value.replace('%', '')}
              style={{ width: '100%' }}
              placeholder={'percentage between 0 to 100'}
              min={0}
              max={100}
            />,
          )}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label={'Due Type'}>
          {getFieldDecorator('due.type', {
            initialValue: get(paymentTerm, 'due.type'),
            rules: rules.select,
          })(<DueTypeSelect placeholder={'Due Type'} />)}
        </Form.Item>
      </Col>
      {!['Deposit', 'On Delivery'].includes(getFieldValue('due.type')) && (
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Due Days'}>
            {getFieldDecorator('due.days', {
              initialValue:
                get(paymentTerm, 'due.days') === 0 ? 0 : get(paymentTerm, 'due.days') || 7,
              rules: rules.select,
            })(<InputNumber style={{ width: '100%' }} placeholder={'Due Days'} />)}
          </Form.Item>
        </Col>
      )}
    </Form>
  )
}

export default Form.create()(PaymentTermsForm)
